import { render } from "./PageFavoris.vue?vue&type=template&id=3457cf80&scoped=true"
import script from "./PageFavoris.vue?vue&type=script&lang=js"
export * from "./PageFavoris.vue?vue&type=script&lang=js"

import "./PageFavoris.vue?vue&type=style&index=0&id=3457cf80&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3457cf80"]])

export default __exports__